// extracted by mini-css-extract-plugin
export default {"flexHeader":"user_flexHeader__DP9TE","subheader":"user_subheader__ptBBy","fields":"user_fields__6VsHE","buttons":"user_buttons__N79L3"};